import { HomeSection } from "@src/features/home/HomeSection";
import InactiveUsersWidget from "@src/features/home/InactiveUsersWidget";
import UsersNotInvitedWidget from "@src/features/home/NotInvitedUsersWidget";
import UsersNoRoleWidget from "@src/features/home/UsersNoRoleWidget";
import IncompleteAssignmentsWidget from "./IncompleteAssignmentsWidget";
import React from "react";

const OverviewOfYourLocationsWidgets: React.FC = () => {
  return (
    <HomeSection title="Overview of your locations">
      <div className="flex gap-3">
        <IncompleteAssignmentsWidget />
        <InactiveUsersWidget />
        <UsersNotInvitedWidget />
        <UsersNoRoleWidget />
      </div>
    </HomeSection>
  );
};

export default OverviewOfYourLocationsWidgets;
